import Constant from '@/const';
import axios from 'axios';

const postGoods = async payload => {
  try {
    const response = await axios.post(
      Constant.apiUrl.concat(`/master/goods/`),
      payload,
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default postGoods;
